import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import SupplierFrameworkTable from './SupplierFrameworkTable';

export default function SupplierFrameworkIndex(props) {
    return (
        <SupplierFrameworkTable
            indexUrl={props.indexUrl}
            importUrl={props.importUrl}
            commonDataUrl={props.commonDataUrl}
            storeUrl={props.storeUrl}
            canEdit={props.canEdit}
            downloadUrl={props.downloadUrl}
            deleteUrl={props.deleteUrl}
            updateUrl={props.updateUrl}
            deleteAttachmentUrl={props.deleteAttachmentUrl}
            locations={props.locations}
            types={props.types}
            areas={props.areas}
        />
    );
}

if (document.getElementById('supplierFramework')) {
    var rootEl = document.getElementById('supplierFramework');
    ReactDOM.render(
        <App>
            <SupplierFrameworkIndex
                indexUrl={indexUrl}
                importUrl={importUrl}
                commonDataUrl={commonDataUrl}
                storeUrl={storeUrl}
                canEdit={!!canEdit}
                downloadUrl={downloadUrl}
                deleteUrl={deleteUrl}
                updateUrl={updateUrl}
                deleteAttachmentUrl={deleteAttachmentUrl}
                locations={locations}
                types={types}
                areas={areas}
            />
        </App>,
        rootEl,
    );
}
